import { HandleMutationResult, handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const withFlash = async <TData>(
  mutationPromise: HandleMutationResult<TData>
): Promise<{ success: boolean }> => {
  const result = await mutationPromise
  const handled = handleResult(result, () =>
    app.setFlash({
      type: 'wrong',
      message: i18n.t('common.error'),
    })
  )

  if (handled.success) {
    app.setFlash({
      type: 'correct',
      message: i18n.t('common.saved_successfully'),
    })
  }

  return handled
}
